import { COMMON_DATA_KEYS as DATA_KEYS } from '../schemas/dataKeys';

export const FORMATTERS = {};

export function getFormatters() {
    return FORMATTERS;
}

export const REQUIRED_FIELDS_FOR_UUID_REQUEST = [DATA_KEYS.NAME];
